<template>
  <div>
    <div class="md-layout-item md-size-100 measurement" v-for="plot in data" :key="plot.id">
      <md-card
        v-if="plot.value.localization.plotType === type"
        md-with-hover :class="plot.value.plot.plot_type !== undefined ? $store.getters.plotTypeLabel(plot.value.plot.plot_type) : $store.getters.eventTypeLabel(plot.value.plot.event_type)"
        @click.native="manage(plot.id)">
        <md-ripple>
          <md-card-content>
            <div class="md-layout md-gutter md-alignment-center-right">
              <div class="md-layout-item md-size-90">
                <span class="plot-info">
                  {{ plot.value.localization.parcel }}\{{ plot.value.localization.sub_parcel }} {{ printDate(plot.value.localization.dt_update) }} {{ plot.value.plot.plot_num }} {{ plot.value.plot.event_num }}
                </span>
              </div>
              <div class="md-layout-item md-size-10">
                <md-icon class="type-icon md-size-2x">
                  <img v-if="plot.value.plot.plot_type === $store.state.plot_type.forest.id" :src="$store.state.icons.plot_type.forest.default[$i18n.locale]" :alt="$store.state.plot_type.forest.label">
                  <img v-if="plot.value.plot.plot_type === $store.state.plot_type.pastures.id" :src="$store.state.icons.plot_type.pastures.default[$i18n.locale]" :alt="$store.state.plot_type.pastures.label">
                  <img v-if="plot.value.plot.plot_type === $store.state.plot_type.shrubs.id" :src="$store.state.icons.plot_type.shrubs.default[$i18n.locale]" :alt="$store.state.plot_type.shrubs.label">
                  <img v-if="plot.value.plot.plot_type === $store.state.plot_type.nonwood.id" :src="$store.state.icons.plot_type.nonwood.default[$i18n.locale]" :alt="$store.state.plot_type.nonwood.label">
                  <img v-if="plot.value.plot.event_type === $store.state.event_type.fire.id" :src="$store.state.icons.event_type.fire.default[$i18n.locale]" :alt="$store.state.event_type.fire.label">
                  <img v-if="plot.value.plot.event_type === $store.state.event_type.erosion.id" :src="$store.state.icons.event_type.erosion.default[$i18n.locale]" :alt="$store.state.event_type.erosion.label">
                  <img v-if="plot.value.plot.event_type === $store.state.event_type.other.id" :src="$store.state.icons.event_type.other.default[$i18n.locale]" :alt="$store.state.event_type.fire.other">
                  <img v-if="plot.value.plot.event_type === $store.state.event_type.illegal_cut.id" :src="$store.state.icons.event_type.illegal_cut.default[$i18n.locale]" :alt="$store.state.event_type.illegal_cut.label">
                </md-icon>
              </div>
            </div>
          </md-card-content>
        </md-ripple>
      </md-card>

      <div class="md-layout md-gutter md-alignment-center-center" :hidden="true" :ref="plot.id">
        <div class="md-layout-item md-size-25">
          <md-button class="md-fab md-primary" @click="edit(plot.id)">
            <md-icon>
              <img src="@/assets/icons/edit.svg" alt="edit">
            </md-icon>
          </md-button>
        </div>
        <div class="md-layout-item md-size-25">
          <md-button class="md-fab md-primary" @click="remove(plot.id)">
            <md-icon>
              <img src="@/assets/icons/delete.svg" alt="delete">
            </md-icon>
          </md-button>
        </div>
        <div class="md-layout-item md-size-25">
          <md-button class="md-fab md-primary" @click="map(plot.id)">
            <md-icon>
              <img src="@/assets/icons/map.svg" alt="map">
            </md-icon>
          </md-button>
        </div>
      </div>
    </div>

    <md-dialog :md-active.sync="del" :md-fullscreen="false">
      <md-dialog-title>{{ $t('home.deleteMsg') }}</md-dialog-title>
      <md-dialog-actions>
        <md-button class="md-primary" @click="removePlot(plotId)">{{ $t('global.yes') }}</md-button>
        <md-button class="md-primary" @click="del = false">{{ $t('global.no') }}</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
export default {
  name: 'PlotList',
  props: ['data', 'db', 'type', 'step'],
  data: () => ({
    del: false,
    plotId: null
  }),
  methods: {
    manage: function (id) {
      this.$refs[id][0].hidden = !this.$refs[id][0].hidden
    },

    edit: function (id) {
      this.$store.commit('plot/getPlot', { db: this.db, id: id })
      this.$store.commit('plot/setId', id)
      this.$router.push(this.step)
    },

    remove: function (id) {
      this.del = true
      this.plotId = id
    },

    removePlot: function (id) {
      this.db.removeItem(id).then(() => {
        this.del = false
        this.manage(id)
        this.$emit('remove')
      }).catch(err => {
        console.log(err)
      })
    },

    map: function (id) {
      this.$router.push({ name: 'Map', params: { id: id } })
    },

    printDate: function (date) {
      let d = new Date(date)
      return ('0' + d.getDate()).slice(-2) + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + d.getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';

  .measurement {
    margin-bottom: 5px;

    .md-layout {
      color: white;
    }

    .md-card-content:last-of-type {
      padding-bottom: 16px !important;
    }

    .plot-info {
      font-size: 125% !important;
    }
  }

  .type-icon {
    float: right;
  }
</style>
